module.exports = __webpack_public_path__ + "static/media/banners.c2c85291.svg";